<div class="page-banner-area">
    <div class="container">
        <div class="page-banner-content">
            <h2>Sponsors</h2>
        </div>
    </div>
</div>



<div class="events-schedules-area" *ngIf="showContactSec">
    <div class="container">

        <div class="row justify-content-center ">

            <div class="partner-area ptb-80 d-none">
                <div class="container">
                    <div class="customers-partner-list">

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/microsoft.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/accimg.png" alt="image">
                            </a>
                        </div>
                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/char.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/ge.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/columbus.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/avid.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/health.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/henny.png" alt="image">
                            </a>
                        </div>

                        <div class="partner-item">
                            <a>
                                <img src="assets/images/partner/kroger.png" alt="image">
                            </a>
                        </div>

                    </div>
                </div>

            </div>

            <div class="row pt-75">
                <div class="col-lg-7 col-md-12">
                    <div class="section-title text-start">
                        <span>Partner with RoundtableCXO </span>
                        <h2>Connect with the Leaders Shaping Enterprise IT</h2>
                    </div>

                    <div class="about-us-content  aboutuscontent">
                        <p>At RoundtableCXO, we work closely with a select group of sponsors and partners who share our
                            vision of
                            empowering senior IT leaders through meaningful dialogue and peer exchange. Our curated
                            roundtable
                            events are designed to deliver real value — not only to attendees, but also to the trusted
                            vendors who
                            help make these conversations possible.</p>
                    </div>


                </div>

                <div class="col-lg-5 col-md-12">

                    <div class="about-us-image">
                        <div class="image-two">

                            <img src="assets/images/sponsers.png" alt="image">
                        </div>

                    </div>
                </div>

                <div class="col-12">
                    <div class="about-us-content pb-75 pl-0">
                        <p>By sponsoring a RoundtableCXO event, your organization has the opportunity to: </p>
                        <ul class="list">

                            <li><i class='bx bx-check'></i> <b>Build trusted relationships</b> with CIOs, CISOs, and
                                senior IT executives in a relaxed,
                                conversation-driven setting</li>
                            <li><i class='bx bx-check'></i> <b>Showcase thought leadership</b> by sharing insights and
                                contributing to relevant, solution-oriented
                                discussions</li>
                            <li><i class='bx bx-check'></i> <b>Gain exposure</b> to a highly targeted and engaged
                                audience of decision-makers across industries</li>
                            <li><i class='bx bx-check'></i><b>Position your brand</b> as a strategic partner to the IT
                                community</li>
                            <li><i class='bx bx-check'></i>Our sponsor partners are more than just supporters — they’re
                                collaborators who help shape the quality,
                                direction, and impact of each event. <b>Thanks to their sponsorship, these exclusive
                                    gatherings remain
                                    free for IT leaders to attend, ensuring that the focus stays on peer-driven
                                    conversations and
                                    industry-leading insights. </b></li>
                            <li><i class='bx bx-check'></i>If you're interested in exploring sponsorship opportunities,
                                we’d love to hear from you. Let’s build
                                something meaningful — together.</li>

                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>



<div class="contact-area ptb-100" *ngIf="showContactSec">
    <div class="container">
        <div class="section-title">
            <h2>Looking to Sponsor?</h2>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="contact-form">
                    <form id="contactForm" [formGroup]="userForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="name" id="name" class="form-control" autocomplete="off"
                                        placeholder="" formControlName="name">
                                    <label for="fname" class="form-label">Name <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['name'].valid && (userForm.controls['name'].touched || submitAttempt)">
                                        Name is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="email" name="email" id="email" class="form-control" autocomplete="off"
                                        placeholder="" formControlName="email">
                                    <label for="fname" class="form-label">Email <sup>*</sup> </label>

                                    <div *ngIf="(userForm.controls['email'].touched || submitAttempt)&& userForm.controls['email'].invalid"
                                        class="text-danger">
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['required']">
                                            Email is required.
                                        </div>
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['pattern']">
                                            Please enter valid email address
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder="" formControlName="company">
                                    <label for="fname" class="form-label">Company <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['company'].valid && (userForm.controls['company'].touched || submitAttempt)">
                                        Company is required
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder="" formControlName="title">
                                    <label for="fname" class="form-label">Title <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['title'].valid && (userForm.controls['title'].touched || submitAttempt)">
                                        Title is required
                                    </div>

                                </div>
                            </div>


                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder=" " formControlName="city">
                                    <label for="fname" class="form-label">Your City <sup>*</sup></label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['city'].valid && (userForm.controls['city'].touched || submitAttempt)">
                                        City is required
                                    </div>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>


                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label float-label-state"
                                    [class.option-selected]="userForm.controls['state'].value">
                                    <select class="form-control blkcolor form-select state-form-select" id="states"
                                        formControlName="state">
                                        <option value="" disabled>State <sup>*</sup></option>
                                        <option *ngFor="let state of states" [value]="state.name"> 
                                            {{ state.name }}
                                        </option>
                                    </select>
                                    <small class="text-danger"
                                        *ngIf="userForm.controls['state'].invalid && (userForm.controls['state'].touched || submitAttempt)">
                                        State is required
                                    </small>
                                </div>
                            </div>



                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" minlength="5" maxlength="5"
                                        class="form-control" autocomplete="off" placeholder=" " formControlName="zip">
                                    <label for="fname" class="form-label">Zip </label>
                                    <small class="text-danger error-block"
                                        *ngIf="(userForm.controls['zip'].touched || submitAttempt) && userForm.controls['zip'].errors?.['minlength']">Please
                                        enter valid zipcode</small>


                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <!-- <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea name="message" class="form-control" id="message" cols="30" rows="5"
                                        required data-error="Write your message" placeholder="Your Message"></textarea>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>  -->

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn" (click)="saveForm()"> Submit
                                    <span></span></button>
                                <div id="msgSubmit" class="h3 text-center hidden"></div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-12">
                <ul class="contact-address">
                    <li>
                        <i class='bx bx-envelope'></i>
                        <h4>Let’s Call or Email</h4>
                        <a href=""><span class="__cf_email__">support&#64;roundtablecxo.com</span></a>
                        <a href="">+1 234 567 8967</a>
                    </li>

                    <li>
                        <i class='bx bx-user'></i>
                        <h4>Our Support Team</h4>
                        <a href=""><span class="__cf_email__">support&#64;roundtablecxo.com</span></a>
                        <a href="">+1 234 567 8967</a>
                    </li>
                </ul>
            </div> -->
        </div>
    </div>
</div>
<div class="loader" *ngIf="loader">
    <div id="loading"></div>
</div>